import React, { useContext } from "react";
import { EnquiryContext } from "venuescanner-js/react/components/Inbox/context/EnquiryContext";
import { MatchThumbnail } from "venuescanner-js/react/components/Inbox/components/Matches/MatchThumbnail";
import MatchesOnboardingPanel from "../MatchesOnboardingPanel";

const MatchesPanel = () => {
  const { organiserLeads = [] } = useContext(EnquiryContext);

  return (
    <div className="matches-panel">
      {organiserLeads && organiserLeads?.length > 0 ? (
        <>
          {organiserLeads.length > 1 && (
            <div className="matches-panel__list">
              <h3 className="matches-panel__list__title">Your events</h3>
              <div className="matches-panel__list__thumbnails">
                {organiserLeads.map((matchEvent) => (
                  <MatchThumbnail
                    key={matchEvent._id}
                    matchEvent={matchEvent}
                  />
                ))}
              </div>
            </div>
          )}
        </>
      ) : null}
      <MatchesOnboardingPanel />
    </div>
  );
};

export default MatchesPanel;
